module.exports = __webpack_public_path__ + "26fd851acad181c193609b97c7f85830.MP3";